import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * Conditional class names, with Tailwind conflict resolution.
 *
 * `clsx` flattens the conditionals; `twMerge` then drops utilities that a later
 * one overrides, so a caller's `className` genuinely wins over a component's own
 * defaults (`cn('px-4', props.className)` with `px-6` yields `px-6`, not both).
 *
 * Use this everywhere instead of writing `twMerge(clsx(...))` out by hand or
 * concatenating class strings. Bare `clsx()` is fine where nothing needs merging.
 */
/**
 * `h-control` and its siblings are the responsive control size (see `tailwind.config.js`). Teaching
 * the merge about them keeps `cn('h-control', 'h-8')` resolving to the later class instead of
 * leaving both on the element.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      h: [{ h: ['control'] }],
      'min-h': [{ 'min-h': ['control'] }],
      w: [{ w: ['control'] }],
      'min-w': [{ 'min-w': ['control'] }],
    },
  },
});

export const cn = (...inputs: ClassValue[]): string => twMerge(clsx(inputs));
